export default __webpack_public_path__ + "static/media/weatherdashboardpic.5f6db86e.png";